import { injectable } from 'tsyringe';
import { Provider } from './Providers/types';
import LoggerConfig from './LoggerConfig';

@injectable()
export default class Logger {
    private provider: Provider;

    private config: LoggerConfig;

    constructor(provider: Provider, config : LoggerConfig = { debug: false }) {
      this.provider = provider;
      this.config = config;
    }

    log = (message: string): void => {
      this.debug(message);
    };

    logException = (exception: Error): void => {
      this.debug(exception);
      this.provider.logException(exception);
    };

    close = async (): Promise<void> => {
      await this.provider.close(this.getCloseTimeout());
    };

    private getCloseTimeout() : number {
      if (typeof this.config.timeout === 'number') {
        return this.config.timeout;
      }
      return 3000;
    }

    private debug(data: any): void {
      if (this.config.debug) console.debug(data);
    }
}
